/**
 * Normaliza o QR Code Pix para uso em <img :src="...">.
 * O campo costuma vir como data URL: `data:image/png;base64,...` ou `data:image/svg+xml;base64,...`
 * ou só o payload base64 (assume PNG nesse caso). Evita prefixo `data:image/...` duplicado.
 */
export function toPixQrCodeDataUrl(value) {
  if (value == null || value === '') {
    return null;
  }
  const s = String(value).trim();
  if (/^data:image\//i.test(s)) {
    return s;
  }
  return `data:image/png;base64,${s}`;
}
